import axios from 'axios'
import { useEffect, useState } from 'react'

//spanish ip access is true, this is specifically for Spanish IP users
async function getSpanishAccess() {
  const result = await axios.get('https://crypto.com/cdn-cgi/trace')
  const matches = result.data.match(/loc=([A-Z]+)/)

  //TODO use JP for test
  if (matches && matches[1] === 'ES') {
    return true
  }
  return false
}

export const useSpanishAccess = () => {
  const [isSpanishAccess, setSpanishAccess] = useState<boolean>(false)
  useEffect(() => {
    const checkSpanishAccess = async () => {
      const isSpanishAccess = await getSpanishAccess()
      setSpanishAccess(isSpanishAccess)
    }
    checkSpanishAccess()
  }, [])
  return isSpanishAccess
}
